var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, ChevronRightRounded, ExpandLessRounded, InsertLinkOutlined } from "@mui/icons-material";
import { Typography } from "@mui/material";
import dayjs from "dayjs";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { MuiStack } from "../../../components";
import StatusColor from "../../../components/atoms/statusColor";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { showNotification } from "../../../redux/commonSlice";
import { useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { purchaseRequisitionGetAPICall } from "../../spareParts/purchaseRequistion/services/apiCall";
import { DeleteSvgIcon, ShareLineSvgIcon } from "../../../assets/customIcons";
import { systemColor } from "../../../theme/systemColor";
import { priorityPickListApiCall } from "../../purchaseOrder/services/apiCalls";
import { PurchaseOrderKeys } from "../../purchaseOrder/services/entity";
import { DownloadIconSVG, PrintIconSVG } from "../../spareParts/purchaseRequistion/assets/customIcons";
import { ShippingMethodListAPI, TransferRequisitionListAPI, TransporterListAPI, uploadWarehouseOutwardAttachment, warehouseListGet, warehouseOutwardCreate, warehouseOutwardGetAPI } from "../apiCalls";
import PartDetails from "../components/interWarehouseOutwordPartDetails";
import { WarehouseOutwardKeys } from "../entity";
import { GoogleAnlyticsErrorLog } from "../../../utils/utils";
export var CreateWarehouseOutward = function () {
    var _getLocalStorageItem, _getLocalStorageItem2, _getLocalStorageItem3, _getPurchaseOrderById4, _getPurchaseOrderById5, _crud$WarehouseOutwar3;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _a = useState(), TransgerReqId = _a[0], setTransgerReqId = _a[1];
    var _b = useState(), grandTotal = _b[0], setGrandTotal = _b[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var searchParams = useSearchParams()[0];
    var id = useParams().id;
    var crud = useAppSelector(function (state) { return state.crud; });
    var getPurchaseOrderByIdData = useAppSelector(function (state) { return state.crud; }).getPurchaseOrderByIdData;
    var mode = searchParams.get('mode');
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var isDisabled = mode !== 'add';
    useEffect(function () {
        warehouseListGet({
            request: {
                TenantId: UserOrganization
            }
        });
    }, []);
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var Identity = (_getLocalStorageItem3 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem3 === void 0 ? void 0 : _getLocalStorageItem3.data.IdentityId;
    useEffect(function () {
        var _getPurchaseOrderById;
        if (getPurchaseOrderByIdData !== null && getPurchaseOrderByIdData !== void 0 && (_getPurchaseOrderById = getPurchaseOrderByIdData.data) !== null && _getPurchaseOrderById !== void 0 && _getPurchaseOrderById.PurchaseProcurementId) {
            var _getPurchaseOrderById2;
            purchaseRequisitionGetAPICall({
                request: {
                    id: getPurchaseOrderByIdData === null || getPurchaseOrderByIdData === void 0 || (_getPurchaseOrderById2 = getPurchaseOrderByIdData.data) === null || _getPurchaseOrderById2 === void 0 ? void 0 : _getPurchaseOrderById2.PurchaseProcurementId
                }
            });
        }
    }, [getPurchaseOrderByIdData === null || getPurchaseOrderByIdData === void 0 ? void 0 : getPurchaseOrderByIdData.data]);
    var handleSearchClick = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var result, profileData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, warehouseOutwardGetAPI({
                        request: {
                            id: value === null || value === void 0 ? void 0 : value.id
                        }
                    })];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && result.data) {
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                    }
                    else {
                        profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', "No requisition found");
                        dispatch(showNotification({
                            isOpen: true,
                            message: "No requisition found",
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var generalDetailsForm = [{
            type: FormItemTypes.CardComponent,
            name: "",
            label: t("Basic details"),
            value: null,
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: "TransferRequisitionID",
                    label: "Transfer requisition ID",
                    value: null,
                    displayExpr: "DocumentCode",
                    valueExpr: "id",
                    apiKey: WarehouseOutwardKeys.transferRequisitionList,
                    // options: crud[WarehouseOutwardKeys.transferRequisitionList]?.data,
                    onChange: function (e, value) {
                        setTransgerReqId(value === null || value === void 0 ? void 0 : value.id);
                    },
                    setFormState: function (formValues, currValue, field) { return __awaiter(void 0, void 0, void 0, function () {
                        var _data$TransportDetail, _data$TransportDetail2, _data$TransportDetail3, _data$TransportDetail4, _data$TransportDetail5, _data$TransportDetail6, _data$TransportDetail7, data;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, handleSearchClick(currValue)];
                                case 1:
                                    data = _a.sent();
                                    return [2 /*return*/, {
                                            SourceWarehouseId: data === null || data === void 0 ? void 0 : data.SourceWarehouseId,
                                            DestinationWarehouseId: data === null || data === void 0 ? void 0 : data.DestinationWarehouseId,
                                            PriorityId: data === null || data === void 0 ? void 0 : data.PriorityId,
                                            TransporterName: data === null || data === void 0 || (_data$TransportDetail = data.TransportDetail) === null || _data$TransportDetail === void 0 ? void 0 : _data$TransportDetail.TransporterId,
                                            ShippingMethod: data === null || data === void 0 || (_data$TransportDetail2 = data.TransportDetail) === null || _data$TransportDetail2 === void 0 ? void 0 : _data$TransportDetail2.ShippingMethodId,
                                            ShippingReferenceDocNo: data === null || data === void 0 || (_data$TransportDetail3 = data.TransportDetail) === null || _data$TransportDetail3 === void 0 ? void 0 : _data$TransportDetail3.ShippingDocumentNo,
                                            ShippingReferenceDocDate: data === null || data === void 0 || (_data$TransportDetail4 = data.TransportDetail) === null || _data$TransportDetail4 === void 0 ? void 0 : _data$TransportDetail4.ShippingDocumentDate,
                                            NoOfBoxes: data === null || data === void 0 || (_data$TransportDetail5 = data.TransportDetail) === null || _data$TransportDetail5 === void 0 ? void 0 : _data$TransportDetail5.BoxQuantity,
                                            VehicleNo: data === null || data === void 0 || (_data$TransportDetail6 = data.TransportDetail) === null || _data$TransportDetail6 === void 0 ? void 0 : _data$TransportDetail6.VehicleNo,
                                            RoadPermitNo: data === null || data === void 0 || (_data$TransportDetail7 = data.TransportDetail) === null || _data$TransportDetail7 === void 0 ? void 0 : _data$TransportDetail7.PermitNo,
                                            StockTransferRequisitionDetail: data === null || data === void 0 ? void 0 : data.StockTransferRequisitionDetail,
                                            ExpectedTransferDate: data === null || data === void 0 ? void 0 : data.ExpectedTransferDate,
                                            ExpectedDeliveryDate: data === null || data === void 0 ? void 0 : data.ExpectedDeliveryDate,
                                            ExpectedPickupDate: data === null || data === void 0 ? void 0 : data.ExpectedPickupDate
                                        }];
                            }
                        });
                    }); },
                    getListData: function (params) { return TransferRequisitionListAPI(_objectSpread(_objectSpread({}, params), {}, {
                        request: _objectSpread(_objectSpread({}, params.request), {}, {
                            SourceTenantId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                            SourceParentTenantId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                            Key: "Completed",
                            Type: "WToWRequisition"
                        })
                    })); }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "SourceWarehouseId",
                    label: "Source warehouse",
                    displayExpr: "DisplayName",
                    valueExpr: "id",
                    apiKey: PurchaseOrderKeys.Warehouse,
                    setFieldProps: function (formValues, currValue) {
                        var _crud$WarehouseOutwar;
                        return {
                            type: FormItemTypes.SearchSelect,
                            options: (_crud$WarehouseOutwar = crud[WarehouseOutwardKeys.warehouseList]) === null || _crud$WarehouseOutwar === void 0 || (_crud$WarehouseOutwar = _crud$WarehouseOutwar.data) === null || _crud$WarehouseOutwar === void 0 ? void 0 : _crud$WarehouseOutwar.filter(function (data) { return (data === null || data === void 0 ? void 0 : data.id) !== (formValues === null || formValues === void 0 ? void 0 : formValues.DestinationWarehouseId); })
                        };
                    },
                    required: true
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "DestinationWarehouseId",
                    label: "Destination warehouse",
                    displayExpr: "DisplayName",
                    valueExpr: "id",
                    apiKey: PurchaseOrderKeys.Department,
                    // options: crud[WarehouseOutwardKeys.warehouseList]?.data?.filter((data: ResponseObject) => !(data?.id === sourceWarehouse)),
                    // onChange: (e, value) => setdestinationWarehouse(value?.id),
                    required: true,
                    setFieldProps: function (formValues, currValue) {
                        var _crud$WarehouseOutwar2;
                        return {
                            type: FormItemTypes.SearchSelect,
                            options: (_crud$WarehouseOutwar2 = crud[WarehouseOutwardKeys.warehouseList]) === null || _crud$WarehouseOutwar2 === void 0 || (_crud$WarehouseOutwar2 = _crud$WarehouseOutwar2.data) === null || _crud$WarehouseOutwar2 === void 0 ? void 0 : _crud$WarehouseOutwar2.filter(function (data) { return (data === null || data === void 0 ? void 0 : data.id) !== (formValues === null || formValues === void 0 ? void 0 : formValues.SourceWarehouseId); })
                        };
                    }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "PriorityId",
                    label: "Priority",
                    getListData: priorityPickListApiCall,
                    valueExpr: "id"
                }],
            columnSize: 12
        }, {
            type: FormItemTypes.CardComponent,
            name: "",
            label: t("Logistic details"),
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: "TransporterName",
                    label: "Transporter name",
                    value: null,
                    displayExpr: "DisplayName",
                    valueExpr: "id",
                    apiKey: WarehouseOutwardKeys.transporterList,
                    getListData: function (params) { return TransporterListAPI({
                        request: {
                            ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId
                        }
                    }); }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "ShippingMethod",
                    label: "Shipping method",
                    value: null,
                    displayExpr: "DisplayName",
                    valueExpr: "id",
                    getListData: ShippingMethodListAPI
                }, {
                    type: FormItemTypes.TextInput,
                    name: "ShippingReferenceDocNo",
                    label: "Shipping reference doc no"
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "ShippingReferenceDocDate",
                    label: "Shipping reference doc date"
                }, {
                    type: FormItemTypes.TextInput,
                    name: "NoOfBoxes",
                    label: "No. of boxes"
                }, {
                    type: FormItemTypes.TextInput,
                    name: "VehicleNo",
                    label: "Vehicle no"
                }, {
                    type: FormItemTypes.TextInput,
                    name: "RoadPermitNo",
                    label: "Road permit no"
                }],
            columnSize: 12
        }];
    var additionalDetailsForm = [{
            type: FormItemTypes.CardComponent,
            name: "Attachments",
            elements: [{
                    type: FormItemTypes.DatePicker,
                    name: "ExpectedTransferDate",
                    label: "Expected transfer date"
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "ExpectedPickupDate",
                    label: "Expected pickup date"
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "ExpectedDeliveryDate",
                    label: "Expected delivery date"
                }],
            columnSize: 12
        }, {
            type: FormItemTypes.CardComponent,
            name: "",
            label: t("Notes and attachments"),
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: "TransferReason",
                    label: "Transfer reason/notes (0/200 characters)",
                    value: null,
                    multiline: true,
                    labelTypographyProps: {
                        variant: "subtitle2"
                    },
                    minRows: 3,
                    md: 6
                }, {
                    type: FormItemTypes.Attachment,
                    name: 'Attachments',
                    label: 'Add attachments',
                    placeholder: 'Upload Files',
                    disabled: isDisabled,
                    value: null,
                    inputProps: {
                        accept: 'application/*',
                        multiple: true
                    },
                    uploadAttachmentRequest: {
                        systemname: WarehouseOutwardKeys.AttachmentSystemName
                    },
                    uploadAttachmentAPI: uploadWarehouseOutwardAttachment
                }],
            columnSize: 12
        }];
    var partDetails = [{
            type: FormItemTypes.Custom,
            name: "StockTransferRequisitionDetail",
            columnSize: 12,
            labelTypographyProps: {
                display: 'none'
            },
            element: PartDetails
        }, {
            type: FormItemTypes.CardComponent,
            name: "",
            columnSize: 12,
            variant: "outlined",
            elements: [{
                    type: FormItemTypes.Box,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: true
                }, {
                    type: FormItemTypes.Button,
                    name: "GrandTotal",
                    label: "",
                    value: null,
                    columnSize: 4,
                    children: /*#__PURE__*/ React.createElement(Typography, {
                        sx: {
                            flexGrow: 1
                        },
                        fontWeight: "bold",
                        textAlign: "left"
                    }, "Grand Total"),
                    variant: "outlined",
                    fullWidth: true,
                    valueGetter: function (formValues, currValue) {
                        var _formValues$PurchaseO;
                        var totalSum = formValues === null || formValues === void 0 || (_formValues$PurchaseO = formValues.PurchaseOrderDetails) === null || _formValues$PurchaseO === void 0 ? void 0 : _formValues$PurchaseO.reduce(function (acc, data) {
                            return acc + data.ModifiedQuantity * data.Rate;
                        }, 0);
                        setGrandTotal(totalSum && totalSum);
                        return totalSum;
                    },
                    sx: {
                        justifyContent: "space-between",
                        bgcolor: "rgba(0,0,0,0.05)",
                        fontWeight: "bold",
                        color: systemColor.secondary
                    },
                    endIcon: grandTotal ? "\u20B9 ".concat(grandTotal) : "₹ 00.00",
                    setFieldProps: function (formValues, currValue) {
                        return {
                            type: this.type,
                            startIcon: formValues !== null && formValues !== void 0 && formValues.Open ? /*#__PURE__*/ React.createElement(ExpandLessRounded, null) : /*#__PURE__*/ React.createElement(ChevronRightRounded, null)
                        };
                    },
                    setFormState: function (formValues, e, field) {
                        return {
                            Open: !(formValues !== null && formValues !== void 0 && formValues.Open)
                        };
                    }
                }]
        }];
    var tabs = [{
            id: "0",
            label: "General",
            elements: generalDetailsForm
        }, {
            id: "1",
            label: "Part details",
            elements: partDetails
        }, {
            id: "2",
            label: "Additional info",
            elements: additionalDetailsForm
        }];
    var formData = [
        // Page Header
        {
            type: FormItemTypes.ContainerItem,
            name: "pageHeader",
            columnSize: 12,
            justifyContent: "space-between",
            alignItems: "center",
            spacing: 0,
            columnSpacing: 1,
            p: 2,
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: "",
                    columnSize: 0,
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small",
                        onClick: function () { return navigate("/interWarehouseOutword"); }
                    })
                }, {
                    type: FormItemTypes.Typography,
                    name: "",
                    children: id ? "Edit inter-warehouse outward" : "New inter-warehouse outward",
                    columnSize: 0,
                    variant: "h1",
                    noWrap: true
                }, {
                    type: FormItemTypes.Custom,
                    name: "",
                    columnSize: 0,
                    element: function () {
                        var _getPurchaseOrderById3;
                        return id ? /*#__PURE__*/ React.createElement(MuiStack, {
                            sx: {
                                border: "1px solid #DEE4EB",
                                borderRadius: "6px",
                                gap: "5px",
                                padding: "3px 8px"
                            },
                            alignItems: "center"
                        }, /*#__PURE__*/ React.createElement(StatusColor, {
                            status: 
                            // documentDetailsGetById?.data?.Key
                            // ??
                            ""
                        }), /*#__PURE__*/ React.createElement(Typography, {
                            sx: {
                                width: 'max-content'
                            },
                            id: "statusKeyId",
                            variant: "h6"
                        }, getPurchaseOrderByIdData === null || getPurchaseOrderByIdData === void 0 || (_getPurchaseOrderById3 = getPurchaseOrderByIdData.data) === null || _getPurchaseOrderById3 === void 0 || (_getPurchaseOrderById3 = _getPurchaseOrderById3.Status) === null || _getPurchaseOrderById3 === void 0 ? void 0 : _getPurchaseOrderById3.Name)) : /*#__PURE__*/ React.createElement(React.Fragment, null);
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    xs: 12,
                    sm: true,
                    item: false,
                    justifyContent: {
                        xs: 'space-between',
                        sm: 'flex-end'
                    },
                    spacing: 0,
                    p: {
                        xs: 2,
                        sm: 0
                    },
                    alignItems: 'center',
                    elements: id ? [{
                            type: FormItemTypes.Typography,
                            name: "",
                            label: "PO NUMBER: ",
                            children: id ? getPurchaseOrderByIdData === null || getPurchaseOrderByIdData === void 0 || (_getPurchaseOrderById4 = getPurchaseOrderByIdData.data) === null || _getPurchaseOrderById4 === void 0 ? void 0 : _getPurchaseOrderById4.DocumentNumber : null,
                            columnSize: 0,
                            containerProps: {
                                display: {
                                    sm: 'flex'
                                },
                                direction: {
                                    sm: 'row'
                                },
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 14
                        }, {
                            type: FormItemTypes.Typography,
                            name: "",
                            label: "PO DATE: ",
                            children: id ? dayjs(getPurchaseOrderByIdData === null || getPurchaseOrderByIdData === void 0 || (_getPurchaseOrderById5 = getPurchaseOrderByIdData.data) === null || _getPurchaseOrderById5 === void 0 ? void 0 : _getPurchaseOrderById5.CreatedOn).format("DD MMM, YYYY") : null,
                            columnSize: 0,
                            // valueFormatter: (value: any) => dayjs(value).format('DD MMM, YYYY'),
                            containerProps: {
                                display: {
                                    sm: 'flex'
                                },
                                direction: {
                                    sm: 'row'
                                },
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 14
                        }] : []
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'flex-end',
            bgcolor: '#EFF2F5',
            setFieldProps: function (formValues, currValue) {
                return {
                    type: this.type,
                    display: {
                        xs: 'none',
                        sm: 'flex'
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            children: "Quick Links",
                            columnSize: 0,
                            variant: "text",
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                            sx: {
                                background: "none"
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(DownloadIconSVG, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            label: "",
                            value: null,
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintIconSVG, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Box,
                            name: "",
                            columnSize: 0,
                            height: "40px",
                            width: "2px",
                            bgcolor: "rgba(0,0,0,0.1)",
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            label: "",
                            value: null,
                            children: /*#__PURE__*/ React.createElement(DeleteSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            label: "",
                            value: null,
                            children: "Save as draft",
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            label: "",
                            value: null,
                            children: "Save",
                            columnSize: 0,
                            variant: "contained",
                            onClick: function () { return 'submit'; }
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: "Stepper",
            value: "0",
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            columnSize: 12,
            variant: 'scrollable',
            tabPanelProps: {
                sx: {
                    px: {
                        xs: 2,
                        sm: 2.5,
                        md: 3
                    }
                }
            },
            sx: {
                paddingX: {
                    xs: 2,
                    sm: 2.5,
                    md: 3
                },
                gap: 2.5
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        }
    ];
    var request = {
        SourceTenantId: UserOrganization,
        SourceParentTenantId: UserParentOrganization,
        DestinationTenantId: UserOrganization,
        DestinationParentTenantId: UserParentOrganization,
        TotalQuantity: 110,
        TotalDamageQuantity: 0,
        TotalExcessQuantity: 0,
        TotalAmount: (_crud$WarehouseOutwar3 = crud[WarehouseOutwardKeys.WrOutwardGet]) === null || _crud$WarehouseOutwar3 === void 0 || (_crud$WarehouseOutwar3 = _crud$WarehouseOutwar3.data) === null || _crud$WarehouseOutwar3 === void 0 ? void 0 : _crud$WarehouseOutwar3.TotalAmount,
        RecordedBy: Identity,
        Type: "WToWRequisition",
        DocumentDate: new Date().toISOString(),
        ParentId: TransgerReqId,
        Status: "Completed"
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: id ? "edit" : "add",
        gridSpacing: 0,
        createFormAPI: warehouseOutwardCreate,
        createKey: WarehouseOutwardKeys.create,
        createRequest: request,
        onClose: function () { return navigate("/interWarehouseOutword"); }
    }));
};
